import { FC } from 'react';
import { Badge, BadgeVariant } from '@new/common/ui/Badge/Badge';

type ProjectStatus = 'pending' | 'inReview' | 'approved' | 'notYet' | 'not_yet';

const STATUS_VARIANTS: Record<ProjectStatus, BadgeVariant> = {
  pending: 'yellow',
  inReview: 'blue',
  approved: 'green',
  notYet: 'red',
  not_yet: 'red',
};

const STATUS_LABELS: Record<ProjectStatus, string> = {
  pending: 'Pending',
  inReview: 'In Review',
  approved: 'Approved',
  notYet: 'Not Yet',
  not_yet: 'Not Yet',
};

interface ProjectStatusBadgeProps {
  status?: string;
}

export const ProjectStatusBadge: FC<ProjectStatusBadgeProps> = ({ status }) => {
  const key = status as ProjectStatus;
  const variant: BadgeVariant = STATUS_VARIANTS[key] ?? 'default';
  const label = STATUS_LABELS[key] ?? status ?? 'Unknown';

  return <Badge variant={variant}>{label}</Badge>;
};
